import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { pages } from "./routes/pages";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

if (document.documentElement.classList.contains("logged-out")) void pages.login.preload();

createRoot(root).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
